export const redirectToMailAgent = (email: string) => {
    window.location.href = `mailto:${email}`;
};
